import React from 'react';
import styles from './header.module.css';

/**
 * Port of lt-components LTTestStatusLabel as kaneai's compact header uses it:
 * solid status-colored pill, white 20×20 stroke icon + capitalized status
 * text. Colors/geometry from LTTheme (spec §statusPill).
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var BG = {
  passed: '#1F883D',
  failed: '#CF222E',
  broken: '#BC4C00',
  // evidence's broken maps to the severe (aborted) tone
  skipped: '#6E7781',
  unknown: '#6E7781'
};
function PillIcon(_ref) {
  var status = _ref.status;
  // White 20×20 glyphs quoted from TestPageComponents assets/status/*.svg.
  if (status === 'passed') {
    return /*#__PURE__*/_jsx("svg", {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      "aria-hidden": "true",
      children: /*#__PURE__*/_jsx("path", {
        d: "M5 10L8.33653 13.9149C8.37522 13.9603 8.4448 13.9619 8.4856 13.9184L15.9091 6",
        stroke: "white",
        strokeWidth: "1.5",
        strokeLinecap: "round"
      })
    });
  }
  if (status === 'failed' || status === 'broken') {
    return /*#__PURE__*/_jsxs("svg", {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      "aria-hidden": "true",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M6 14L14 6M6 14L14 6",
        stroke: "white",
        strokeWidth: "1.2",
        strokeLinecap: "round"
      }), /*#__PURE__*/_jsx("path", {
        d: "M14 14L6 6L12.5806 12.5806",
        stroke: "white",
        strokeWidth: "1.2",
        strokeLinecap: "round"
      })]
    });
  }
  // skipped/unknown — kaneai's skipped glyph family: simple dash.
  return /*#__PURE__*/_jsx("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    "aria-hidden": "true",
    children: /*#__PURE__*/_jsx("path", {
      d: "M6 10H14",
      stroke: "white",
      strokeWidth: "1.5",
      strokeLinecap: "round"
    })
  });
}
export function StatusPill(_ref2) {
  var status = _ref2.status;
  var label = status === 'unknown' ? 'unknown' : status;
  return /*#__PURE__*/_jsxs("span", {
    className: styles.statusPill,
    style: {
      backgroundColor: BG[status]
    },
    children: [/*#__PURE__*/_jsx(PillIcon, {
      status: status
    }), label]
  });
}